import type { ReactElement } from 'react';
import { str } from './item-form-utils.js';

type Props = {
  qtyOnHand: number;
  qtyReserved: number;
  qtyAvailable: number;
  binLocation: unknown;
  qtyOnOrder: unknown;
  onAdjust: () => void;
};

export function StockSection({
  qtyOnHand,
  qtyReserved,
  qtyAvailable,
  binLocation,
  qtyOnOrder,
  onAdjust,
}: Props): ReactElement {
  return (
    <section id="section-stock" className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-slate-950">Stock</h2>
        <button
          type="button"
          onClick={onAdjust}
          className="rounded-xl border border-slate-300 px-3 py-1.5 text-sm font-semibold"
        >
          Adjust
        </button>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        <div className="rounded-xl bg-slate-50 p-4">
          <div className="text-xs font-semibold uppercase text-slate-500">On hand</div>
          <div className="mt-1 text-2xl font-bold">{qtyOnHand}</div>
        </div>
        <div className="rounded-xl bg-slate-50 p-4">
          <div className="text-xs font-semibold uppercase text-slate-500">Reserved</div>
          <div className="mt-1 text-2xl font-bold">{qtyReserved}</div>
        </div>
        <div className="rounded-xl bg-slate-50 p-4">
          <div className="text-xs font-semibold uppercase text-slate-500">Available</div>
          <div className="mt-1 text-2xl font-bold">{qtyAvailable}</div>
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-500">
        Bin: {str(binLocation, '—')} · On order: {str(qtyOnOrder, '0')}
      </p>
    </section>
  );
}
